export default {
	methods: {
		fieldState (form, field) {
			if (this.fieldError(form, field) === '') {
				return null
			}

			return false
		},
		fieldError (form, field) {
			if (form.hasErrors === false) {
				return ''
			}

			for(const err in form.errors) {
				if(!form.errors.hasOwnProperty(err)) {
					continue
				}

				if (_.has(form.errors, field)) {
					return form.errors[field]
				}

				if (_.has(form.errors[err], field)) {
					return form.errors[err][field]
				}
			}

			return ''
		}
	}
}
